import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=1af3adeb&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=1af3adeb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3adeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af3adeb')) {
      api.createRecord('1af3adeb', component.options)
    } else {
      api.reload('1af3adeb', component.options)
    }
    module.hot.accept("./Team.vue?vue&type=template&id=1af3adeb&scoped=true", function () {
      api.rerender('1af3adeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/Team.vue"
export default component.exports